import { render, staticRenderFns } from "./PointEdit.vue?vue&type=template&id=0da1f4b0&scoped=true&"
import script from "./PointEdit.vue?vue&type=script&lang=js&"
export * from "./PointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1f4b0",
  null
  
)

export default component.exports